import { createGlobalStyle } from "styled-components";

const styled = { createGlobalStyle };

const GlobalStyles = styled.createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: inherit;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
  }

  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: transparent;
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  html,
  body {
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  html {
    height: 100%;
    font-size: 62.5%; // 1rem = 10px, 10/16 = 60.25%
    box-sizing: border-box;
    font-family: DM Sans;
    overflow-x: hidden;
    user-select: none;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    font-feature-settings: "kern" 1;
  }

  body {
    box-sizing: border-box;
    background-color: #0e0e12;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /* Skeleton placeholders tokom loading-a */
  img[loading="lazy"]:not([src]) {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.05) 25%,
      rgba(255, 255, 255, 0.1) 50%,
      rgba(255, 255, 255, 0.05) 75%
    );
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
  }

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }

  input,
  button,
  select {
    outline: none;
  }

  #cf-turnstile {
    width: 100% !important;
    max-width: 100%;
    display: block;
  }
  #cf-turnstile > div {
    width: 100% !important;
    display: flex;
    justify-content: center;
  }

  li {
    font-size: 14px;
  }

  @media (max-width: 400px) {
    #cf-turnstile {
      scale: 0.925;
    }
    #cf-turnstile > div {
      scale: 0.925;
    }
  }
`;

export default GlobalStyles;
